import { auth } from "../firebase";

// Development logging helper
const isDevelopment = process.env.NODE_ENV === "development";
const log = (...args) => {
  if (isDevelopment) console.log(...args);
};
const logError = (...args) => {
  if (isDevelopment) console.error(...args);
};

// API configuration for production and development
export const getApiBaseUrl = () => {
  // ALWAYS use hardcoded URLs - ignore environment variables completely
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  ) {
    log("[getApiBaseUrl] Using localhost proxy");
    return "/api"; // Use proxy for localhost
  }

  log("[getApiBaseUrl] Using hardcoded production URL");
  return "https://adminapi-nd4j3oddma-uc.a.run.app"; // Production API (Admin Panel)
};

const API_BASE_URL = getApiBaseUrl();

export const apiCall = async (endpoint, options = {}) => {
  // Backwards compatibility: allow apiCall(endpoint, 'GET') style
  if (typeof options === "string") {
    options = { method: options };
  }

  // Force refresh token if expired (Firebase auto-renews if > 55min old)
  let idToken = null;

  console.log("[API_CALL] auth.currentUser:", auth.currentUser?.email);

  try {
    if (auth.currentUser) {
      idToken = await auth.currentUser.getIdToken(true);
      console.log("[API_CALL] Token acquired:", idToken ? "✅ YES" : "❌ NO");
    } else {
      console.warn("[API_CALL] No currentUser - skipping auth");
    }
  } catch (tokenError) {
    console.error("[API_CALL] Failed to get auth token:", tokenError);
    throw new Error("Authentication failed. Please login again.");
  }
  // Normalize endpoint and join
  const normalizedEndpoint = `/${String(endpoint || "").replace(/^\/*/, "")}`; // ensure single leading '/'
  const base = API_BASE_URL.replace(/\/+$/, "");
  const url = `${base}${normalizedEndpoint}`;
  log(`[API_CALL] Requesting: ${options.method || "GET"} ${url}`);

  const headers = {
    "Content-Type": "application/json",
    ...(options && options.headers ? options.headers : {}),
  };

  if (idToken) {
    headers.Authorization = `Bearer ${idToken}`;
  }

  const config = {
    ...(options || {}),
    headers,
  };

  try {
    const response = await fetch(url, config);
    const responseText = await response.text();
    log(`[API_CALL] Response text for ${endpoint}:`, responseText);

    if (!response.ok) {
      let errorData;
      try {
        errorData = JSON.parse(responseText);
      } catch (e) {
        errorData = { message: responseText };
      }
      logError(`[API_CALL] API Error for ${endpoint}:`, {
        status: response.status,
        data: errorData,
      });
      throw new Error(
        errorData.error ||
          errorData.message ||
          `HTTP error! status: ${response.status}`
      );
    }

    try {
      const jsonData = JSON.parse(responseText);
      log(`[API_CALL] Parsed JSON for ${endpoint}:`, jsonData);
      return jsonData;
    } catch (e) {
      logError(
        `[API_CALL] API response is not valid JSON for ${endpoint}:`,
        responseText
      );
      throw new Error("Received non-JSON response from server.");
    }
  } catch (error) {
    logError(`[API_CALL] Network or other error for ${endpoint}:`, error);
    throw error; // Re-throw the error to be caught by the caller
  }
};

export default API_BASE_URL;
